import React from 'react';
import { passwordValidationStyles } from '../utils/constant';

const PasswordValidationHelper = ({ passwordValidation, renderValidationIcon }) => {
  const satisfiedConditions = [
    passwordValidation.minLength,
    passwordValidation.hasUppercase && passwordValidation.hasLowercase,
    passwordValidation.hasNumber && passwordValidation.hasSpecialChar
  ].filter(Boolean).length;

  return (
    <div className="invoice-popup-container mt-3">
      <div style={{ marginBottom: '0.8vh', display: 'flex', gap: '0.8vh' }}>
        {[0, 1, 2].map(index => (
          <div key={index} style={{
            flex: 1,
            backgroundColor: index < satisfiedConditions ? passwordValidationStyles.progressBarColors.active : passwordValidationStyles.progressBarColors.inactive,
            ...passwordValidationStyles.progressBar
          }}></div>
        ))}
      </div>
      <div>
        <div style={{ display: 'flex', alignItems: 'flex-start', ...passwordValidationStyles.textStyles }}>
          <div style={{ marginTop: '0.2vh' }}>{renderValidationIcon(passwordValidation.minLength)}</div>
          <span>8+ characters</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'flex-start', ...passwordValidationStyles.textStyles }}>
          <div style={{ marginTop: '0.2vh' }}>{renderValidationIcon(passwordValidation.hasUppercase && passwordValidation.hasLowercase)}</div>
          <span>Upper and Lower case letters</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'flex-start', fontSize: '1.4vh' }}>
          <div style={{ marginTop: '0.2vh' }}>{renderValidationIcon(passwordValidation.hasNumber && passwordValidation.hasSpecialChar)}</div>
          <span>A number and a symbol</span>
        </div>
      </div>
    </div>
  );
};

export default PasswordValidationHelper;